import type { ReactNode } from 'react';
import { cn } from '../cn';

interface FormFieldProps {
  label: ReactNode;
  htmlFor?: string;
  error?: ReactNode;
  helper?: ReactNode;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export function FormField({
  label,
  htmlFor,
  error,
  helper,
  required,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-fg-primary block">
        {label}
        {required && (
          <span className="text-negative ml-1" aria-hidden>
            *
          </span>
        )}
      </label>
      {children}
      {error && <p className="text-sm text-negative">{error}</p>}
      {!error && helper && <p className="text-sm text-fg-secondary">{helper}</p>}
    </div>
  );
}
